export const MIN_HOURS_RESERVATION = 4;
export const HOURS_IN_ADVANCE = 24;
export const MIN_LENGTH_PASSWORD = 4;
export const MAX_LENGTH_PASSWORD = 12;